import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { toast } from "sonner";

const emptyForm = { name: "", industry: "", website: "", email: "", phone: "", city: "", country: "" };

export default function CompanyFormDialog({ open, onOpenChange, company = null, onSaved }) {
    const [form, setForm] = useState(emptyForm);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open) setForm(company ? { ...emptyForm, ...company } : emptyForm);
    }, [open, company]);

    const save = async () => {
        if (!form.name.trim()) { toast.error("Nombre de empresa obligatorio"); return; }
        setSaving(true);
        try {
            const payload = { ...form, name: form.name.trim() };
            const { data } = company?.company_id
                ? await api.patch(`/companies/${company.company_id}`, payload)
                : await api.post("/companies", payload);
            toast.success(company ? "Empresa actualizada" : "Empresa creada");
            onOpenChange(false);
            onSaved?.(data);
        } catch (error) {
            toast.error(formatApiError(error.response?.data?.detail));
        } finally { setSaving(false); }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader><DialogTitle>{company ? "Editar" : "Nueva"} empresa</DialogTitle></DialogHeader>
                <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2"><Label>Nombre *</Label><Input value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} data-testid="company-form-name"/></div>
                    <div><Label>Industria</Label><Input value={form.industry} onChange={(e)=>setForm({...form, industry:e.target.value})}/></div>
                    <div><Label>Sitio web</Label><Input value={form.website} onChange={(e)=>setForm({...form, website:e.target.value})}/></div>
                    <div><Label>Email</Label><Input value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})}/></div>
                    <div><Label>Teléfono</Label><Input value={form.phone} onChange={(e)=>setForm({...form, phone:e.target.value})}/></div>
                    <div><Label>Ciudad</Label><Input value={form.city} onChange={(e)=>setForm({...form, city:e.target.value})}/></div>
                    <div><Label>País</Label><Input value={form.country} onChange={(e)=>setForm({...form, country:e.target.value})}/></div>
                </div>
                <DialogFooter><Button variant="ghost" onClick={()=>onOpenChange(false)}>Cancelar</Button><Button onClick={save} disabled={saving} data-testid="company-form-save">{saving ? "Guardando…" : "Guardar"}</Button></DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
